import getImageUrl from '../../../functions/getImageUrl'
import ListItem from '../presents/ListItem'

const ListItemImageContainer = ({
    imgKey='img',
    itemType,
    itemData,
    additionalClass,
    isSelected,
    pathnameEdit,
    onDelete,
}) => {
    const image = itemData[imgKey] && itemData[imgKey].url ? itemData[imgKey] : null
    const {finalImageURl, imageUrl} = getImageUrl(image, false, true)

    return <ListItem
        title={false}
        showImage={true}
        imageSrc={finalImageURl}
        imageSrcFallback={imageUrl}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemImageContainer